import React from 'react';
// @ts-ignore
import destinations from '../data/data5.json';

export const defaultProps = {
    options: destinations.sort((a, b) => {
        if (a.name < b.name) {
            return -1;
        }
        if (a.name > b.name) {
            return 1;
        }
        return 0;
    }),
    getOptionLabel: (option) => option.name
     + ', ' + option.country + ', ' + option.flag,
};

export function getCityFromid(id) {
    return destinations.find((city) => city.id === id);
}

export function getidFromCity(name) {
    return destinations.find((city) => city.name === name)?.id;
}

export function getCityFromName(name) {
    return destinations.find((city) => city.name === name);
}

export function getCityScores(city) {
    const cityData = getCityFromName(city);
    if (cityData && cityData.scores) {
        return cityData.scores;
    }
    return [];
}

export function getCitySeasonality(city){
    const cityData = getCityFromName(city);
    if (cityData && cityData.seasonality) {
        const seasonalityScore = cityData.seasonality;
        return (seasonalityScore);
    }
    return [];
}

export function getCityInterests(id){
    const cityData = getCityFromid(id);
    if (cityData && cityData.interests) {
        const interests = cityData.interests ;
        return (interests);
    }
    return [];
}

export function getCityTemperature(city){
    const cityData = getCityFromName(city);
    if (cityData && cityData.temperature) {
        const temperature = cityData.temperature;
        return (temperature);
    }
    return [];
}